module.exports = __webpack_public_path__ + "static/media/Account_Team_Members.40bc22f9.mp4";